import styled from '@emotion/styled';

import { css } from '@emotion/react';

import {
	MYPAGE_MOBILE_BP,
	mypageFieldBoxCss,
	mypageFlexRowMobileCss,
	mypageFormContainerCss,
	mypageGenderBoxMobileCss,
	mypageSubPageTitleCss,
	mypageSubmitAreaCss,
} from '@/components/MyPage/shared/subPageStyles';

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
	max-width: 44rem;
	width: 100%;
	${mypageFormContainerCss}
`;
export const Title = styled.h2`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: 600;
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	${mypageSubPageTitleCss}
`;
export const MenuBoxList = styled.div`
	display: flex;
	width: 100%;
`;
export const MenuBox = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 0.8rem;
	padding: 2rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: 600;
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #dee2e6;
	background-color: #f1f3f5;
	.sub_title {
		color: #495057;
	}
	&.active {
		background-color: ${(props) => props.theme.colors.primary400};
		.sub_title {
			color: #fff;
		}
	}
`;
export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	${mypageFieldBoxCss}
`;
export const SelectBox = styled.div`
	height: 4.4rem;
`;
export const FieldCheckBox = styled.label`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: 400;
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	justify-content: flex-end;
`;
export { NextButton, FindButton } from '@/components/common/Button/style';
export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.4rem;
	width: 100%;
	height: 4.4rem;
	${mypageFlexRowMobileCss}
	div {
		flex: 1;
	}
	input {
		flex: 1;
	}
`;

const emailFlexRowMobileCss = css`
	@media screen and (max-width: ${MYPAGE_MOBILE_BP}) {
		flex-wrap: wrap;
		height: auto;
		row-gap: 0.8rem;

		& > div {
			flex: 1 1 calc(50% - 1.6rem);
			min-width: 0;
		}

		& > button {
			flex: 1 1 100%;
			width: 100%;
		}
	}
`;

export const EmailAt = styled.span`
	flex-shrink: 0;
	line-height: 4.4rem;
`;

export const EmailFlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.4rem;
	width: 100%;
	min-height: 4.4rem;

	& > div {
		flex: 1;
		min-width: 0;
	}

	${emailFlexRowMobileCss}
`;
export const GenderBox = styled.div`
	display: flex;
	gap: 4rem;
	${mypageGenderBoxMobileCss}
`;
export const GenderRadio = styled.div`
	display: flex;
	gap: 0.4rem;
	input[type='radio'] {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		width: 20px;
		height: 20px;
		border: 1px solid #ced4da;
		border-radius: 50%;
		outline: none;
		cursor: pointer;
	}
	input[type='radio']:checked {
		background-color: #fff;
		border: 6px solid ${(props) => props.theme.colors.primary400};
	}
	label {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.4rem;
		cursor: pointer;
	}
`;
export const AddressInput = styled.input`
	width: 100%;
	&:read-only {
		background-color: #e9ecef;
		border: 1px solid #adb5bd;
	}
`;
export const AddressBox = styled.div`
	display: flex;
	gap: 0.4rem;
	height: 4.4rem;
`;
export const AddressContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
`;
export const TabBox = styled.div`
	display: flex;
	width: 100%;
	height: 4.4rem;
	background-color: #fff;
	color: #868e96;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	.tab {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		height: 100%;
		border: 1.4px solid #adb5bd;
		&.active {
			border: 1px solid ${(props) => props.theme.colors.primary400};
			color: ${(props) => props.theme.colors.primary400};
		}
	}
`;
export const Danger = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: ${(props) => props.theme.colors.red600};
`;
export const PasswordInput = styled.input`
	height: 4.4rem;
	padding: 0 1.2rem;
	border: 1px solid #adb5bd;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212121;
	width: 100%;
	&:focus {
		outline-color: ${(props) => props.theme.colors.primary400};
	}
	&::placeholder {
		color: #adb5bd;
	}
	&:read-only {
		background-color: #e9ecef;
		border: 1px solid #adb5bd;
	}
`;
export const SecessionButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	color: #495057;
	height: 4rem;
	padding: 0 1.2rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	border: none;
	width: 100%;
	cursor: pointer;
	width: fit-content;
`;
export const ButtonBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	${mypageSubmitAreaCss}
	.button_wrap {
		display: flex;
		justify-content: center;
		width: 100%;
	}
`;
